var React = require('react');
var moment = require('moment');
var Helpers = require("../../utils/helpers");
import ReactDOM from 'react-dom';

import CollectionRes from "../../resources/collection";
import ConceptRes from '../../resources/concept';
import RaisedButton from 'material-ui/RaisedButton';
import '../../css/components/ExamEditor/exam_editor.css';
import '../../css/components/Tasks/Review/review_collection.css';
import '../../css/components/QuestionContent/content_play.css';
import { browserHistory } from 'react-router';
import notification from '../Modal/notification';
import ViewExam from './ViewExam';
import async from 'async';

var ExamEditor = React.createClass({

    retrieveConceptsMap: function(callback) {
        callback = callback || function() {};
        var _this = this;
        ConceptRes.retrieveAllConceptsMap(function(err, conceptsMap) {
            _this.setState({
                conceptsMap: (!err && conceptsMap) ? conceptsMap : {},
            }, function() {
                return callback(err, conceptsMap);
            })
        })
    },
    genarateTable: function(object, concept, tableConcept) {
        var concept = concept?concept:"empty";
        if (object[concept]) {
            object[concept].count++;
        } else {
            if (tableConcept) {
                tableConcept.countConcept += 1;
            }
            if (concept) {
                object[concept] = {
                    "_id": concept,
                    "count": 1,
                    "title": this.state.conceptsMap[concept] ? this.state.conceptsMap[concept].title : concept
                }
            } 
            if(object._id=="0e63c066-be4d-4a92-889b-0cfade16a546"){
                console.log(object, concept);
            }
            if (!object.countChild) {
                object.countChild = 1;
            } else {
                object.countChild += 1;
            }
        }
    },
    genarateTableQuestion: function(object, key) {
        if (object[key]) {
            object[key].count += 1;
        } else {
            object[key] = {
                "count": 1,
                "title": key
            }
            if (!object.countChild) {
                object.countChild = 1;
            } else {
                object.countChild += 1;
            }
        }
    },
    deleteItemByKeyArray: function(arrObject, key, value) {
        for (var i in arrObject) {
            if (arrObject[i]) {
                if (arrObject[i][key] == value) {
                    arrObject = arrObject.splice(i, 1);
                    return;
                }
            }
        }
    },
    addQuestionCollection: function(collectionId, question) {
        this.setState({
                isChange: true
        })
        this.state.collection.questions.unshift({
            numPoints: question.score,
            kquestion: question,
            questionRef: question._id,
            type: this.state.currentPart
        });
        this.calculatorDataCollection(this.state.collection);
    },
    deleteQuestionCollection: function(collectionId, questionId) {
        // this.state.QuestionsWillBeDelete[questionId] = {
        //     questionId: questionId,
        //     collectionId: collectionId
        // }
        this.setState({
                isChange: true
        })
        this.deleteItemByKeyArray(this.state.collection.questions, "questionRef", questionId);
        this.calculatorDataCollection(this.state.collection);
        // console.log(this.state.QuestionsWillBeDelete);
    },
    calculatorDataCollection: function(data, callback) {
        callback = callback || function() {};
        var _this = this;
        var countMCQ = 0;
        var countSS = 0;
        var countLS = 0;
        var countMCQScore = 0;
        var countSSScore = 0;
        var countLSScore = 0;
        var tableConcept = {};
        var tableQuestion = {};
        var currentQuestions = {};
        tableConcept.countConcept = 0;
        for (var j in data.questions) {
            currentQuestions[data.questions[j].questionRef] = data.questions[j];
            data.questions[j].questionIndex = j;
            var conceptsLength = data.questions[j].kquestion.concepts.length;
            var concept0 = data.questions[j].kquestion.concepts[conceptsLength - 3];
            var concept1 = data.questions[j].kquestion.concepts[conceptsLength - 4];
            var concept2 = data.questions[j].kquestion.concepts[conceptsLength - 5];
            _this.genarateTable(tableConcept, concept0);
            _this.genarateTable(tableConcept[concept0], concept1);
            _this.genarateTable(tableConcept[concept0][concept1], concept2, tableConcept);



            if (data.questions[j].kquestion.type == 11) {
                _this.genarateTableQuestion(tableQuestion, "50 mins");
                _this.genarateTableQuestion(tableQuestion["50 mins"], "MCQ");
                _this.genarateTableQuestion(tableQuestion["50 mins"]["MCQ"], data.questions[j].numPoints);
                countMCQ++;
                countMCQScore += data.questions[j].numPoints;
            }
            if (data.questions[j].kquestion.type == 21) {
                _this.genarateTableQuestion(tableQuestion, "50 mins");
                _this.genarateTableQuestion(tableQuestion["50 mins"], "Short Questions");
                _this.genarateTableQuestion(tableQuestion["50 mins"]["Short Questions"], data.questions[j].numPoints);
                countSS++;
                countSSScore += data.questions[j].numPoints;
            }
            if (data.questions[j].kquestion.type == 22) {
                _this.genarateTableQuestion(tableQuestion, "100 mins");
                _this.genarateTableQuestion(tableQuestion["100 mins"], "Long Questions");
                _this.genarateTableQuestion(tableQuestion["100 mins"]["Long Questions"], data.questions[j].numPoints);
                countLS++;
                countLSScore += data.questions[j].numPoints;
            }
        }
        data.MCQ = countMCQ;
        data.SS = countSS;
        data.LS = countLS;
        data.total = countMCQ + countSS + countLS;
        tableConcept.count = data.total;
        tableQuestion.count = data.total;
        data.MCQScore = countMCQScore;
        data.SSScore = countSSScore;
        data.LSScore = countLSScore;
        data.totalScore = countMCQScore + countSSScore + countLSScore;
        _this.setState({
            collection: data,
            currentQuestions: currentQuestions,
            tableConcept: tableConcept,
            tableQuestion: tableQuestion
        }, function() {
            callback();
        });
    },
    retrieveCollection: function(collectionId, callback) {
        callback = callback || function() {};
        var _this = this;
        var options = {}
        options.collectionId = collectionId;
        options.query = {
            sortQuestion: '+questionIndex'
        }
        CollectionRes.retrieveSingleCollection(options, function(err, data) {
            if (err) return console.log(err);
            if (data) {
                _this.setState({
                    collection: data
                }, function() {
                    _this.calculatorDataCollection(data, function() {
                        _this.setState({
                            QuestionsDataOld: _this.state.currentQuestions
                        }, function() {
                            callback();
                        })
                    });
                })
            }
        })
    },
    retrieveQuestionsOfConcept: function(conditions, callback) {
        callback = callback || function() {};
        var options = {};
        options.conditions = conditions;
        options.limit = 15;
        ConceptRes.retrieveAllQuestionOfConcept(options, function(err, data) {
            callback(err, data);
        })
    },
    retrieveUserCourses: function(callback) {
        callback = callback || function() {};
        var _this = this;
        ConceptRes.retrieveUserCourses(function(err, courses) {
            var coursesMap = {};
            courses.map(function(course, index) {
                coursesMap[course._id] = course.title;
            });
            _this.setState({
                coursesMap: coursesMap
            })
            return callback(err, coursesMap);
        })
    },
    getInitialState: function() {
        return {
            isChange: false,
            isLoading: true,
            isProcessing: false,
            collection: null,
            currentQuestions: null,
            conceptsMap: null,
            currentAnswerIndex: 0,
            currentPart: "PART_1",
            tableConcept: {
                countConcept: 0,
                count: 0
            },
            tableQuestion: {
                count: 0
            },
            coursesMap: null,
            QuestionsDataOld: {}
        };
    },
    submitCollection: function() {
        var _this = this;
         this.setState({
            isProcessing: true
        });
        var QuestionsWillBeDelete = [];
        Object.keys(_this.state.QuestionsDataOld).forEach(function(key) {
            var oldQuestion = _this.state.QuestionsDataOld[key];
            if (!_this.state.currentQuestions[oldQuestion.questionRef]) {
                QuestionsWillBeDelete.push(oldQuestion);
            }
        })

        async.parallel([
            function(callback) {
                var dataDelete = [];
                async.eachLimit(QuestionsWillBeDelete, 10, function(question, cb) {
                    CollectionRes.DeleteQuestion(_this.state.collection._id, question.questionRef, function(err, data) {
                        dataDelete = data;
                        cb();
                    });
                }, function() {
                    callback(null, dataDelete);
                })
            },
            function(callback) {
                var dataUpdate = [];
                async.eachLimit(_this.state.collection.questions, 10, function(question, cb) {
                    CollectionRes.UpdateKQuestion(_this.state.collection._id, question, function(err, data) {
                        dataUpdate = data;
                        cb();
                    })
                }, function() {
                    callback(null, dataUpdate);
                })
            }
        ], function(err, data) {
             _this.setState({
                isProcessing: false
            });
            if (err) console.log(err);
            notification.open({
                        message: 'Success',
                        description: "Mock Exam has been saved!"
            })
        })
    },
    sortQuestion: function() {
        if (this.state.collection) {
            this.setState({
                    isChange: true
            })
            this.state.collection.questions.sort(function(a, b) {
                     var parts = ["PART_1","PART_2"];
                     var types = [11, 21, 22];
                     var aVal = parts.indexOf(a.type) * 100 + types.indexOf(a.kquestion.type) * 10 + a.numPoints;
                     var bVal = parts.indexOf(b.type) * 100 + types.indexOf(b.kquestion.type) * 10 + b.numPoints;
                     if(aVal == bVal){
                        return a.kquestion.dateCreated - b.dateCreated;
                     }
                     return(aVal - bVal);
                     // return (a.kquestion.type > b.kquestion.type) ? 1 : ((b.kquestion.type > a.kquestion.type) ? -1 : 0); 
           });
        }
    },
    publishCollection: function() {
        var _this = this;
        var collection = _this.state.collection;
        collection.status = "published";
        collection.instance_status = "published";
        // if(collection.totalScore!=100){
        //     return notification.open({
        //         message: 'Notice!',
        //         description: "The total mark must be equal to 100"
        //     })
        // }
        _this.setState({
            isProcessing: true
        });
        CollectionRes.updateCollectionOnly(collection, function(err, data) {
            _this.setState({
                isProcessing: false
            });
            if (err) {
                return notification.open({
                    message: 'Error',
                    description: 'Cannot save Mock Exam. Please try again'
                })
            }
            browserHistory.push('/mock-exams');
            notification.open({
                message: 'Success',
                description: "Mock Exam has been published!"
            })
           
        });
    },
    setCurrentPart: function(part){
            this.setState({
                currentPart: part
            })
    },
    rejectCollection: function() {
                var _this = this;
                var collection = _this.state.collection;
                collection.status = "rejected";
                if(collection.instance_status === 'processing') {
                    collection.status = 'deleted'
                }
                this.setState({
                    isProcessing: true
                });
                CollectionRes.updateCollectionOnly(collection, function(err, data) {
                    _this.setState({
                          isProcessing: false
                   });
                    if (err) {
                        return notification.open({
                            message: 'Error',
                            description: 'Cannot save Mock Exam. Please try again'
                        })
                    }
                    browserHistory.push('/mock-exams');
                    notification.open({
                        message: 'Success',
                        description: "Mock Exam has been rejected!"
                    })
                   
                });
    },
    render: function() {
        var _this = this;
        return (
            <div>
                {
                    !_this.state.isLoading&&_this.state.collection&&
                    <div className="content-toolbar">
                        <h3>Review Mock Exam</h3>
                        <div className="btn-holder">
                            {(_this.state.collection.status === "to_be_reviewed") &&

                                    <div>
                                                    {_this.state.isProcessing&&
                                                         <img src="https://cdn.zenquiz.net/static/Assets/loading-animation.gif"></img>
                                                    }
                                                    {!_this.state.isProcessing&&
                                                            <div>
                                                                                <RaisedButton
                                                                                        label="PUBLISH"
                                                                                        labelColor="white"
                                                                                        backgroundColor="#4dc3ca" 
                                                                                        onClick={_this.publishCollection}
                                                                                        icon={<i className="fa fa-upload"
                                                                                        style={{color: "white"}}></i>}/>
                                                                                <RaisedButton
                                                                                        label="SAVE CHANGES"
                                                                                        labelColor="white" 
                                                                                        backgroundColor="#dc4c4a"
                                                                                        icon={<i className="fa fa-floppy-o" style={{color: "white"}}></i>}
                                                                                        onClick={_this.submitCollection}
                                                                                        />
                                                                                <RaisedButton
                                                                                        label="REJECT"
                                                                                        labelColor="white"
                                                                                        backgroundColor="#999999"
                                                                                        onClick={_this.rejectCollection}
                                                                                        icon={<i className="fa fa-times" style={{color: "white"}}></i>}/>
                                                            </div>
                                                    }
                                             
                                    </div>
                            }
                           
                        </div>
                        <hr/>
                        <h2>{_this.state.collection.title}</h2>
                        <div className='header-exam-editor'>
                                <span className='head-title'>Question/ Point:</span> <span className='head-value'>{_this.state.collection.total} / {_this.state.collection.totalScore}</span>
                                <span className='head-title'>| MCQ:</span> <span className='head-value'> {_this.state.collection.MCQ} / {_this.state.collection.MCQScore} </span>
                                <span className='head-title'> SS:</span> <span className='head-value'> {_this.state.collection.SS} / {_this.state.collection.SSScore} </span>
                                <span className='head-title'> LS:</span> <span className='head-value'> {_this.state.collection.LS} / {_this.state.collection.LSScore} </span>
                                <span className='head-title'>| Subject:</span> <span className='head-value'> {_this.state.coursesMap[_this.state.collection.course]}</span>
                        </div>
                        <ViewExam
                                data={this.state.collection}
                                currentQuestions={this.state.currentQuestions}
                                currentPart={this.state.currentPart}
                                courses={this.state.coursesMap}
                                conceptsMap={this.state.conceptsMap}
                                conceptArr={this.state.conceptArr}
                                tableConcept={this.state.tableConcept}
                                tableQuestion={this.state.tableQuestion}
                                retrieveCollection={this.retrieveCollection}
                                deleteQuestionCollection={this.deleteQuestionCollection}
                                addQuestionCollection={this.addQuestionCollection}
                                calculatorDataCollection={this.calculatorDataCollection}
                                retrieveQuestionsOfConcept={this.retrieveQuestionsOfConcept}
                                setCurrentPart={this.setCurrentPart}
                                sortQuestion={this.sortQuestion}
                        />
                    </div>
                }

             </div>
        )
    },

    componentDidMount: function() {
        var _this = this;
        _this.retrieveUserCourses();
        _this.retrieveConceptsMap(function(err, conceptsMap) {
            _this.retrieveCollection(_this.props.params.examId);
            _this.setState({
                isLoading: false
            })
        });

    },
    componentDidUpdate: function() {
        var __this = this;
        window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub, ReactDOM.findDOMNode(__this)]);
    },
});

export default ExamEditor;


/** WEBPACK FOOTER **
 ** ./src/components/ExamEditor/ExamEditor.js
 **/